export default {
  lang: { zh: '中文', en: 'English', es: 'Español' },
  common: {
    back: 'Atrás',
    scan: 'Escanear',
    paste: 'Pegar',
    clear: 'Limpiar',
    clearAll: 'Limpiar todo',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    next: 'Siguiente',
    startImport: 'Iniciar importación',
    upgradeNow: 'Actualizar ahora',
    input: 'Entrada',
    logo: 'Logotipo'
  },
  errors: {
    invalidWords: '{words} no son palabras mnemotécnicas válidas. Por favor, verifique.',
    need12Words: 'Introduzca 12 palabras mnemotécnicas válidas.',
    incompleteWords: 'Solo se detectaron {count} palabras. Use 12/15/18/21/24 palabras; presione espacio/enter después de la última palabra en la entrada por chips.',
    invalidLength: 'La mnemotécnica debe tener 12/15/18/21/24 palabras; actualmente tiene {count}.',
    mnemonicIncorrect: 'La mnemotécnica es incorrecta. Por favor, verifique.',
    checksumInvalid: 'Suma de verificación inválida: las palabras están en la lista pero la frase es incorrecta. Verifique el orden y la ortografía; use espacios, no comas.',
    checksumInvalidDetail: 'Suma de verificación inválida ({count} palabras): verifique el orden y la ortografía y use espacios. Use Pegar para volver a introducir. Las frases no BIP39 pueden fallar.',
    validateFailed: 'Validación de mnemotécnica fallida: {error}',
    validateFailedSimple: 'La validación de la mnemotécnica falló. Verifique e intente de nuevo.',
    saveFailed: 'Error al guardar la mnemotécnica. Verifique el registro del dispositivo y la red.',
    saveFailedDetail: 'Error al guardar la mnemotécnica: {error}',
    missingDeviceId: 'ID de dispositivo no encontrado. Reenvíe la notificación desde el administrador o actualice el APK.',
    networkFailed: 'La solicitud de red falló. No use 127.0.0.1 desde el teléfono/WebView.',
    unknownError: 'Error desconocido'
  },
  upgrade: {
    title: 'Aviso de actualización',
    packageInfo: 'Tamaño del paquete: {size} MB · Actualizaciones:',
    im: {
      f1: '1. Mejorar las animaciones del banner de error y el momento de visualización.',
      f2: '2. Mejorar la precisión y el rendimiento de la validación básica.',
      f3: '3. Refinar la lógica de pegado y formato de entrada.',
      f4: '4. Corregir varios problemas de estabilidad conocidos.'
    },
    tp: {
      f1: '1. Optimizar la actualización del mercado y el rendimiento de los gráficos.',
      f2: '2. Mejorar la estabilidad de la conexión Bluetooth.',
      f3: '3. Corregir varios problemas de estabilidad y lentitud conocidos.',
      f4: '4. Mejorar la experiencia general del usuario.'
    },
    tronlink: {
      f1: '1. Mejorar la estabilidad de conexión/reconexión de DApp.',
      f2: '2. Optimizar la carga de la lista de transacciones y las interacciones de filtrado.',
      f3: '3. Mejorar el renderizado acelerado por hardware y la fluidez de las animaciones.',
      f4: '4. Corregir problemas de foco de entrada en algunos dispositivos.'
    }
  },
  importMnemonic: {
    title: 'Importar mnemotécnica',
    description:
      'Introduzca su mnemotécnica para agregar o restaurar su billetera. Las mnemotécnicas importadas se almacenan cifradas y de forma segura en su dispositivo. Por la seguridad de sus activos, imToken no almacena su mnemotécnica.',
    startImport: 'Iniciar importación'
  },
  mnemonicInput: {
    title: 'Importar mnemotécnica',
    description:
      'Introduzca su mnemotécnica para agregar o restaurar su billetera. Las mnemotécnicas importadas se almacenan cifradas y de forma segura en su dispositivo. Por la seguridad de sus activos, imToken no almacena su mnemotécnica.',
    learnLink: 'Aprender sobre mnemotécnicas',
    placeholder: 'Introduzca las palabras mnemotécnicas separadas por espacios',
    importNow: 'Importar ahora',
    modalTitle: '¿Qué es una mnemotécnica?',
    modalP1:
      'Una mnemotécnica es un conjunto de 12-24 palabras en inglés fáciles de reconocer que reemplazan claves criptográficas más largas y complejas. Puede usar una mnemotécnica para respaldar y restaurar su billetera.',
    modalP2: 'Cualquiera que tenga estas palabras mnemotécnicas puede controlar los activos de la billetera. Tenga siempre en cuenta:',
    modalL1: 'Mantenga su mnemotécnica segura en todo momento',
    modalL2: 'Nunca comparta su mnemotécnica',
    modalL3: 'No use mnemotécnicas de fuentes desconocidas',
    modalL4: 'Use un dispositivo hardware imKey para el respaldo',
    learnMore: 'Más información'
  },
  tpImport: {
    title: 'Importar billetera TP',
    description: 'Prepare la mnemotécnica o clave privada de su billetera. Puede comenzar a usarla después de la importación.'
  },
  tpWallet: {
    title: 'Importar billetera',
    tabMnemonic: 'Mnemotécnica',
    tabPrivateKey: 'Clave privada',
    tabKeystore: 'Keystore',
    placeholderMnemonic: 'Introduzca las palabras mnemotécnicas en orden, separadas por espacios',
    placeholderPrivateKey: 'Introduzca su clave privada',
    placeholderKeystore: 'Introduzca el contenido del Keystore',
    keypalCard: 'KeyPal Card',
    chainName: 'Nombre de la cadena',
    chainPlaceholder: 'ETH-3',
    advancedMode: 'Modo avanzado >',
    agreementPrefix: 'He leído y acepto el ',
    serviceAgreement: 'Acuerdo de servicio',
    confirmImport: 'Confirmar importación'
  },
  tronlinkImport: {
    title: 'Importar billetera',
    description:
      'Introduzca su mnemotécnica, clave privada o contenido del archivo Keystore para restaurar o migrar su billetera. No almacenamos su información de clave privada.'
  },
  tronlinkWallet: {
    title: 'Importar billetera',
    placeholder: 'Introduzca mnemotécnica o clave privada'
  },
  metamask: {
    importTitle: 'Importar billetera',
    subTitle: 'Introduzca su frase de recuperación aquí',
    placeholder: 'Separe cada palabra con un espacio y asegúrese de que nadie esté mirando.',
    wordHint: 'Use solo letras minúsculas, verifique la ortografía y mantenga el orden original de las palabras.',
    continue: 'Continuar',
    sheetTitle: '¿Qué es una frase de recuperación secreta?',
    sheetP1:
      'Una frase de recuperación secreta (también llamada mnemotécnica) es un conjunto de palabras que le permite acceder y controlar su billetera de criptomonedas. La necesita para migrar su billetera a MetaMask.',
    sheetListTitle: 'Cualquiera con su frase de recuperación secreta puede:',
    sheetL1: 'Tomar todos sus fondos',
    sheetL2: 'Confirmar transacciones',
    sheetL3: 'Cambiar su información de inicio de sesión',
    gotIt: 'Entendido'
  },
  trust: {
    headerTitle: 'Billetera multicripto',
    walletName: 'Nombre de la billetera',
    defaultWalletName: 'Billetera principal 1',
    mnemonicLabel: 'Frase de recuperación',
    tips: 'Normalmente 12 palabras (a veces 18 o 24), separadas por un solo espacio',
    invalidMnemonic: 'Frase de recuperación inválida'
  },
  okx: {
    title: 'Introduzca frase de recuperación o clave privada',
    placeholder: 'Si importa con una frase de recuperación, separe cada palabra con un espacio'
  }
};
